import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { API } from '../../module/mexal/index';
import AsyncAutocomplete from '../form/components/AsyncAutocomplete.component';

const MexalForm = () => {
  const { watch, setValue } = useFormContext();
  const watchMexalVal = watch('mexal_validation');
  const watchMexalCompany = watch('mexal');

  useEffect(() => {
    if (!watchMexalVal && watchMexalCompany) setValue('mexal', null);
  }, [watchMexalVal, watchMexalCompany, setValue]);

  return (
    <AsyncAutocomplete
      id='mexal'
      label='Mexal Company'
      name='mexal'
      api={API.mexalCustomers}
      disabled={!watchMexalVal}
    />
  );
};

export default MexalForm;
